function discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById('cartp-apply-discount');
  if (!discountCodeApplyBtn) return;

  const wrongCodeText   = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText   = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById('cartp-discount-message');
  const spinner         = document.getElementById('cartp-spinner');
  const invalidCodes    = new Set();

  const discountSectionLabel = document.getElementById('cartp__discount-section__label');
  const discountCodeInput = document.getElementById('cartp__discount-code');

  // Clear message on focus  
  if (discountCodeInput && discountMessage) {
    discountCodeInput.addEventListener('focus', () => {
      discountMessage.textContent = '';
      discountMessage.style.color = 'var(--neutral-1000)';
      discountSectionLabel.style.color = 'var(--neutral-1000)';
      discountCodeInput.style.border = '1px solid var(--neutral-1000)';
    });
  }

  discountCodeApplyBtn.addEventListener('click', async () => {
    const discountCodeInput = document.getElementById('cartp__discount-code');
    const discountCode      = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    spinner.style.display = "block";
    try {
      // Fetch current cart
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map(dc => dc.code)
        .filter(code => code && !invalidCodes.has(code));
                   
        const updatedCodes = [...existingCodes, discountCode];
        const updateRes    = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: updatedCodes.join(',') }),
        });
        const updateData = await updateRes.json();
        const newCodeEntry = updateData.discount_codes?.find(dc => dc.code === discountCode);

        if (!newCodeEntry?.applicable) {
          discountMessage.textContent = wrongCodeText;
          discountMessage.style.color = '#A92626';
          discountSectionLabel.style.color = '#A92626';
          discountCodeInput.style.border = '1px solid #A92626';
          invalidCodes.add(discountCode);
        } else {
          discountMessage.textContent = successCodeText;
          discountMessage.style.color = '#939E95';
          discountSectionLabel.style.color = '#939E95';
          discountCodeInput.style.border = '1px solid #939E95';
        }      

      // finally refresh counts & drawer
      const updatedCart = await (await fetch('/cart.js')).json();
      updateCartItemCounts(updatedCart.item_count);
      await updateCartDrawer();

    } catch (err) {
      console.error('Discount error:', err);
      discountMessage.textContent = wrongCodeText;
      discountMessage.style.color = '#A92626';
      discountSectionLabel.style.color = '#A92626';
      discountCodeInput.style.border = '1px solid #A92626';
    } finally {
      spinner.style.display = "none";
    }
  });
}


document.addEventListener("click", async (e) => { //put click on the dom because after section rendering, if event was on click we would loose it
  const minusBtn = e.target.closest(".cartpage-quantity-selector-minus");
  const plusBtn = e.target.closest(".cartpage-quantity-selector-plus");

  if (!minusBtn && !plusBtn) return;

  const itemRow = e.target.closest("[data-line-item-key]");
  if (!itemRow) return;

  const key = itemRow.dataset.lineItemKey;
  const input = itemRow.querySelector("input[type='number']");
  let quantity = parseInt(input.value, 10);

  if (plusBtn) {
    quantity++;
  } else if (minusBtn) {
    quantity = Math.max(0, quantity - 1);
  }

  await updateCartItem(key, quantity);
});


document.querySelectorAll(".cart-page__remove").forEach(async (btn) => {
    btn.addEventListener("click", async () => {
      const key = btn.dataset.line;
      
      await updateCartItem(key, 0);
    });
  })

// update quantity function
async function updateCartItem(key, quantity) {
  try {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });

    // render cart section 
    const res = await fetch(`${window.location.pathname}?section_id=cart`);
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newCart = doc.querySelector(".cartpage-form");
    document.querySelector(".cartpage-form").innerHTML = newCart.innerHTML;
  } catch (err) {
    console.error("Cart update failed", err);
  }
}


discountCodeApplying();